import React from "react";
import styled from "styled-components";
import Robot from  "../../../assets/images/mask/robot.gif";
export default function WelcomeChat() {
    const firstName = localStorage.getItem("userFirstName");
    const lastName = localStorage.getItem("userLastName");
 
  return (
    <Container>
      <img src={Robot} alt="" />
      <h1>
        Welcome, <span>{firstName} {lastName}!</span>
      </h1>
      <h3>Please select a chat to Start messaging.</h3>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  flex-direction: column;
  img {
    height: 20rem;
  }
  span {
    color: #4e0eff;
  }
  h3{
    text-align: center;
    width: 80%;
  }

  h1{
    text-align: center;
    width:500px;
  }
`;